// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2kIg_","label":"Section_label__UtwJt","contentWrap":"Section_contentWrap__3P_Mb","footer":"Section_footer__1sgSW","footerInner":"Section_footerInner__1Mgf3"};